import React, { Component } from 'react';
import PropTypes from 'prop-types';

class KeyBoardSelector extends Component {
  constructor(props) {
    super(props);
    this.scrollRef = null;
    this.state = {
      activeItemKey: null,
    };
  }

  componentDidMount() {
    const { listenerElement, scrollToElementOnOpen } = this.props;
    if (!listenerElement) return;
    listenerElement.addEventListener('keydown', this.handleKeyDown);

    if (scrollToElementOnOpen && !!this.itemToScrollToRef) {
      try {
        const scrollBounding = this.scrollRef.getBoundingClientRect();
        const itemToScrollBounding =
          this.itemToScrollToRef.getBoundingClientRect();

        this.scrollRef.scrollTop =
          this.scrollRef.scrollTop + itemToScrollBounding.y - scrollBounding.y;
      } catch (e) {
        console.error('Error scrollToElmenetOnOpen: ', e);
      }
    }
  }

  componentWillUnmount() {
    const { listenerElement } = this.props;
    if (!listenerElement) return;
    listenerElement.removeEventListener('keydown', this.handleKeyDown);
  }

  getNewActiveItem = (key, { state, props }) => {
    const { children } = props;

    const options = React.Children.toArray(children);

    const { activeItemKey } = state;
    let tmpActiveItemKey =
      key === 'ArrowDown' ? activeItemKey + 1 : activeItemKey - 1;

    if (
      options[tmpActiveItemKey] &&
      options[tmpActiveItemKey].props.noSelectWithKeyBoard
    ) {
      if (key === 'ArrowDown') {
        tmpActiveItemKey += 1;
      } else {
        tmpActiveItemKey -= 1;
      }
    }

    if (
      (activeItemKey === null && key === 'ArrowDown') ||
      tmpActiveItemKey === options.length
    ) {
      return 0;
    }

    if ((activeItemKey === null && key === 'ArrowUp') || tmpActiveItemKey < 0) {
      return options.length - 1;
    }

    return tmpActiveItemKey;
  };

  handleKeyDown = (e) => {
    if (!['ArrowDown', 'ArrowUp', 'Enter'].includes(e.key)) return;

    if (e.key === 'Enter') {
      const { children, propagatedPropsOnClick } = this.props;
      const options = React.Children.toArray(children);
      const { activeItemKey } = this.state;
      if (activeItemKey === null) {
        return;
      }

      const option = options[activeItemKey];
      if (!option) return;

      const { onClick } = option.props;

      if (!onClick) return;

      onClick(
        propagatedPropsOnClick.reduce(
          (acc, key) => ({
            ...acc,
            [key]: option.props[key],
          }),
          {}
        )
      );

      return;
    }

    this.setState(
      (state, props) => ({
        activeItemKey: this.getNewActiveItem(e.key, { state, props }),
      }),
      this.handleItemPosition
    );
  };

  handleItemPosition = () => {
    if (!this.activeItemKeyRef) return;

    const scrollBounding = this.scrollRef.getBoundingClientRect();
    const itemBounding = this.activeItemKeyRef.getBoundingClientRect();

    const scrollElementBottom = scrollBounding.y + scrollBounding.height;
    const itemElementBottom = itemBounding.y + itemBounding.height;

    if (itemElementBottom > scrollElementBottom) {
      this.scrollRef.scrollTop =
        this.scrollRef.scrollTop +
        Math.abs(
          scrollBounding.y +
            scrollBounding.height -
            (itemBounding.y + itemBounding.height)
        );
    }

    const scrollElementTop = scrollBounding.y;
    const itemElementTop = itemBounding.y;
    if (itemElementTop < scrollElementTop) {
      this.scrollRef.scrollTop =
        this.scrollRef.scrollTop + itemBounding.y - scrollBounding.y;
    }
  };

  handleRef = (ref) => {
    this.scrollRef = ref;
  };

  handleItemRef = (ref) => {
    this.activeItemKeyRef = ref;
  };

  handleItemToScrollToRef = (ref) => {
    this.itemToScrollToRef = ref;
  };

  render() {
    const { children, className, listenerElement, minWidth } = this.props;
    const { activeItemKey } = this.state;

    const windowWidth =
      window && window.innerWidth ? window.innerWidth * 0.85 : 0;
    const listenerWidth =
      listenerElement && listenerElement.offsetWidth
        ? listenerElement.offsetWidth * 1.25
        : 120;
    const itemWidth = `${
      windowWidth > listenerWidth ? listenerWidth : windowWidth
    }px`;

    return (
      <div
        ref={this.handleRef}
        className={className}
        style={{ minWidth: minWidth ? minWidth : itemWidth }}
      >
        {React.Children.map(
          children,
          (element, key) =>
            element &&
            React.cloneElement(element, {
              ...element.props,
              active: activeItemKey === key,
              activeRef: activeItemKey === key ? this.handleItemRef : undefined,
              scrollToRef: element.props.scrollOnOpen
                ? this.handleItemToScrollToRef
                : undefined,
            })
        )}
      </div>
    );
  }
}

KeyBoardSelector.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  listenerElement: PropTypes.instanceOf(Element).isRequired,
  propagatedPropsOnClick: PropTypes.arrayOf(PropTypes.string),
};

KeyBoardSelector.defaultProps = {
  className: '',
  propagatedPropsOnClick: ['value'],
};

export default KeyBoardSelector;
